<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { dispatchExerciseChangeEvent } from "./Util/utils";
  import { onMount } from 'svelte';
  export let phoneView: boolean;

  export let joined: boolean = false;
  export let session_id: string;
  export let start_date: string;
  export let end_date: string;
  export let in_progress: boolean;

  export let current_time: any;
  export let current_time_highres: any;
  export let show_leave_anchor = true;

  export let shorten_text = false;
  export let is_group_session = true;
  let username = Xert._username;
  let jq = window.$;
  let chartURL = `/video?view=chart&user=${username}`;
  let gaugeURL = `/video?view=power&user=${username}`;
  let chartWindow = function(){
    window.open(chartURL, `_chart`, 'toolbar=0, menubar=0, location=0, width=1200,height=300');
  }
  let gaugeWindow = function(){
    window.open(gaugeURL, `_gauge`, 'toolbar=0, menubar=0, location=0, width=400px,height=400px');
  }
  let waiting = false;
  $: if (joined || !joined) waiting = false;

  let button: HTMLButtonElement;
  onMount(() => {
    jq('[data-toggle=tooltip]').tooltip({container: 'body'});//Tooltips used in bootstrap button groups must have this set
    jq('[data-toggle=tooltip]').tooltip();
  });

  export let joinSession: (string, bool?)=>Promise<any>;
  function joinThisSession() {
    waiting = true;
    return joinSession(session_id).catch(error=>{
      if (error.type == "overlap") {
        let message;
        if (error.n < 2) {
          message = "You have an overlapping session scheduled. Leave that session and join this one?";
        } else {
          message = "You have overlapping sessions scheduled. Leave these sessions and join this one?";
        }
        if(confirm(message)) {
          // Force join session, which clears conflicts.
          return joinSession(session_id, true);
        }
      } else {
        setTimeout(()=>alert(error.msg));
      }
      return Promise.reject(error.message);
    }).finally(()=>{
      waiting=false;
      dispatchExerciseChangeEvent(button);
    });

  }
  function startSession() {
    window.location.assign("/video")
  }
  function joinAndStart() {
    waiting = true;
    joinThisSession().then(startSession);
  }
  function preventDefault(e) {
    e.preventDefault();
  }


  $: start_date_obj = new Date(start_date);
  $: end_date_obj = new Date(end_date);

  $: in_past = start_date_obj < $current_time;
  $: not_yet_ended = $current_time_highres < end_date_obj;
  $: starting_soon = !in_past && $current_time.getTime()+2*3600*1000 > start_date_obj.getTime();
  $: in_progress = in_past && not_yet_ended;
</script>

<!-- Join button -->
{#if not_yet_ended}
  {#if !is_group_session || in_progress}
    {#if joined}
      <div class="btn-group">
        <button bind:this={button} class="btn inprog grouped-btn" style={phoneView && "flex-grow: 1;"} class:waiting class:joined_inprog={!is_group_session || joined} on:click={waiting ? ()=>{}: joined ? startSession : joinAndStart} title="Open Player">
          <i style={!waiting && "display: none;"} class:fa-regular={waiting} class:fa-hourglass-half={waiting}/>
          <svg style={waiting && "display: none;"} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.745117 1.41192C0.745178 1.29832 0.774263 1.18663 0.829613 1.08743C0.884963 0.988234 0.964742 0.904826 1.06138 0.84512C1.15802 0.785414 1.26831 0.751392 1.38179 0.746281C1.49527 0.74117 1.60817 0.76514 1.70978 0.815916L14.8858 7.40392C14.9964 7.45934 15.0894 7.54444 15.1543 7.6497C15.2193 7.75496 15.2537 7.87622 15.2537 7.99992C15.2537 8.12362 15.2193 8.24488 15.1543 8.35013C15.0894 8.45539 14.9964 8.54049 14.8858 8.59592L1.70978 15.1839C1.60817 15.2347 1.49527 15.2587 1.38179 15.2536C1.26831 15.2484 1.15802 15.2144 1.06138 15.1547C0.964742 15.095 0.884963 15.0116 0.829613 14.9124C0.774263 14.8132 0.745178 14.7015 0.745117 14.5879V1.41192Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="btn inprog grouped-btn" style={phoneView && "flex-grow: 1;"} title="Power Gauge" on:click={gaugeWindow}>
          <i class="fa-light fa-gauge fa-lg"></i>
        </button>
        <button class="btn inprog grouped-btn" style={phoneView && "flex-grow: 1;"} title="Workout Chart" on:click={chartWindow}>
          <i class="fa-light fa-chart-simple fa-lg"></i>
        </button>
      </div>
    {:else}
      <button bind:this={button} class="btn" style={phoneView && "flex-grow: 1;"} class:waiting on:click={waiting ? ()=>{}: joinThisSession}>
        <i style={!waiting && "display: none;"} class:fa-regular={waiting} class:fa-hourglass-half={waiting}/>
        <p>{$_(shorten_text ? "sessions.browser.join_short" : "sessions.browser.join")}</p>
      </button>
    {/if}
    {#if show_leave_anchor}
      {#if is_group_session}
        {#if joined}
          <button bind:this={button} class="btn btn-leave" style={phoneView && "flex-grow: 1;"} on:auxclick={preventDefault} on:click={joinThisSession}>
            <p>Leave</p>
          </button>
        {/if}
      {/if}
    {/if}
  {:else if joined}
    {#if starting_soon}
      <div class="btn-group">
        <button bind:this={button} class="btn inprog grouped-btn" style={phoneView && "flex-grow: 1;"} class:waiting class:joined_inprog={!is_group_session || joined} on:click={waiting ? ()=>{}: joined ? startSession : joinAndStart} title="Open Player">
          <i style={!waiting && "display: none;"} class:fa-regular={waiting} class:fa-hourglass-half={waiting}/>
          <svg style={waiting && "display: none;"} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.745117 1.41192C0.745178 1.29832 0.774263 1.18663 0.829613 1.08743C0.884963 0.988234 0.964742 0.904826 1.06138 0.84512C1.15802 0.785414 1.26831 0.751392 1.38179 0.746281C1.49527 0.74117 1.60817 0.76514 1.70978 0.815916L14.8858 7.40392C14.9964 7.45934 15.0894 7.54444 15.1543 7.6497C15.2193 7.75496 15.2537 7.87622 15.2537 7.99992C15.2537 8.12362 15.2193 8.24488 15.1543 8.35013C15.0894 8.45539 14.9964 8.54049 14.8858 8.59592L1.70978 15.1839C1.60817 15.2347 1.49527 15.2587 1.38179 15.2536C1.26831 15.2484 1.15802 15.2144 1.06138 15.1547C0.964742 15.095 0.884963 15.0116 0.829613 14.9124C0.774263 14.8132 0.745178 14.7015 0.745117 14.5879V1.41192Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="btn inprog grouped-btn" style={phoneView && "flex-grow: 1;"} title="Power Gauge" on:click={gaugeWindow}>
          <i class="fa-light fa-gauge fa-lg"></i>
        </button>
        <button class="btn inprog grouped-btn" style={phoneView && "flex-grow: 1;"} title="Workout Chart" on:click={chartWindow}>
          <i class="fa-light fa-chart-simple fa-lg"></i>
        </button>
      </div>
    {:else}
      <button bind:this={button} class="btn" class:joined={true} class:waiting class:starting_soon class:inprog={in_past && not_yet_ended} style={phoneView && "flex-grow: 1;"} on:click={waiting ? ()=>{}: starting_soon ? startSession : joinThisSession}>
        <i style={!waiting && "display: none;"} class:fa-regular={waiting} class:fa-hourglass-half={waiting}/>
        <p class="btn-text-normal">{$_("sessions.browser.already_joined")}</p>
        <p class="btn-text-hover">{$_("sessions.browser.leave")}</p>
      </button>
    {/if}
    {#if starting_soon && show_leave_anchor}
      <button bind:this={button} class="btn btn-leave" style={phoneView && "flex-grow: 1;"} on:auxclick={preventDefault} on:click={joinThisSession}>
        <p>Leave</p>
      </button>
    {/if}
  {:else}
    <button bind:this={button} class="btn" style={phoneView && "flex-grow: 1;"} class:waiting on:click={waiting ? ()=>{}: joinThisSession}>
      <i style={!waiting && "display: none;"} class:fa-regular={waiting} class:fa-hourglass-half={waiting}/>
      <p>{$_(shorten_text ? "sessions.browser.join_short" : "sessions.browser.join")}</p>
    </button>
  {/if}
{/if}

<style lang="scss">

button {
  @import './style/xert.scss';

  display: flex;
  justify-content: center;
  width: var(--xert-button-width, 200px);

  background: var(--color-xert-teal);
  margin: 10px 0px;

  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  /* identical to box height */
  text-align: center;
  letter-spacing: 0.48px;

  position: relative;
  > svg, > i {
    margin: 4px;
  }

  > p {
    margin: 0;
    position: relative;
    top: 1px;
    padding: 0px 5px;
  }

  /* identical to box height */
  text-align: center;
  letter-spacing: 0.48px;
  transition: background 0.4s;

  color: #FFFFFF;

  &:not(.waiting) {
    &:not(.joined):hover{
      background: var(--color-xert-lime);
    }

    &.inprog {
      background: var(--color-xert-blue);
    }

    &.joined {
      background: var(--color-xert-lime);
      &.starting_soon {
        background: var(--color-xert-blue);
        &:hover {
          background: var(--color-xert-lime);
        }
      }
    }
    &.joined:not(.starting_soon) {

      > .btn-text-hover {
        display: none;
      }
      &:hover {
        background: var(--color-xert-gray);

        > .btn-text-normal {
          display: none;
        }

        > .btn-text-hover {
          display: unset !important;
        }
      }
    }
  }
}


.btn-leave {
  background: white;
  border: 1px solid var(--color-xert-blue);
  color: var(--color-xert-blue);
}

.btn-leave:hover {
  background: var(--color-xert-blue) !important;
  color: white;
}
.bottomlink {
  margin-top: 20px;
  display: block;
}

.btn-group {
  display: flex;
  max-width: var(--xert-button-width);
  width: 100%;
  flex-grow: 1;
}
.grouped-btn {
  width: auto;
  min-width: 56.5px;
  height: 38px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
}
</style>
